import { useCallback, useEffect, useState, useSyncExternalStore } from 'react'
import { me } from '@/core/data/session'
import {
  cachedAmpelSchwellen,
  getAmpelSchwellen,
  subscribeAmpelSchwellen,
} from '@/core/data/organisationAmpel'
import { DEFAULT_AMPEL_SCHWELLEN, type AmpelSchwellen } from '@/core/lib/ampel'

export function useAmpelSchwellen(): AmpelSchwellen {
  const [organisationId, setOrganisationId] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    me()
      .then(({ organisationId: id }) => {
        if (cancelled) return
        setOrganisationId(id)
        if (!cachedAmpelSchwellen(id)) return getAmpelSchwellen(id)
      })
      .catch((e) => console.error('Ampel-Schwellen laden fehlgeschlagen:', e))
    return () => {
      cancelled = true
    }
  }, [])

  const snapshot = useCallback(
    () => (organisationId && cachedAmpelSchwellen(organisationId)) || DEFAULT_AMPEL_SCHWELLEN,
    [organisationId],
  )
  return useSyncExternalStore(subscribeAmpelSchwellen, snapshot, snapshot)
}
